import type { AuditSource } from '../../../data/useAuditFeed';

/**
 * One colour per audit source, shared by the table and the timeline so the two
 * views of the same feed agree. Impersonation is red: it is the only row on
 * this page that names a member of staff inside a customer's account. These are design-system palette names, which
 * the `Badge` resolves to theme tokens, so both grounds stay legible.
 */
export const SOURCE_COLOR: Record<AuditSource, string> = {
  transfers: 'blue',
  'opt-in': 'cyan',
  deliveries: 'violet',
  'flow-runs': 'green',
  ledger: 'orange',
  impersonations: 'red'
};

/** The catalogue key naming each source, so no source name is raw English. */
export const SOURCE_LABEL_KEY: Record<AuditSource, string> = {
  transfers: 'audit.kpi.transfers',
  'opt-in': 'audit.kpi.optIn',
  deliveries: 'audit.kpi.deliveries',
  'flow-runs': 'audit.kpi.flowRuns',
  ledger: 'audit.kpi.ledger',
  impersonations: 'audit.kpi.impersonations'
};

/**
 * The same six colours as CSS custom properties, for the rule down the left
 * edge of a timeline row. `Badge` resolves its palette name internally, and a
 * border cannot ask it to, so the token is named here once.
 */
export const SOURCE_ACCENT: Record<AuditSource, string> = {
  transfers: 'var(--rr-color-blue-500)',
  'opt-in': 'var(--rr-color-cyan-500)',
  deliveries: 'var(--rr-color-violet-500)',
  'flow-runs': 'var(--rr-color-green-500)',
  ledger: 'var(--rr-color-orange-500)',
  impersonations: 'var(--rr-color-red-500)'
};
